// Modules
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import type { RootState } from '../../types/store';
import PickCard from "./pick-gamecard";
import HeaderWithBackNav from "../../components/ui-header-back";


const Create = () => {
    const translate = useSelector((state:RootState) => state.ui.language);

    return (
        <Grid container>
            <Grid size={{xs: 12}}>
                <HeaderWithBackNav text={translate.create.gameMode} size="lg" target="/" />
            </Grid>
            {translate.modes.map((v, i) => {
                return(<Grid key={i} size={{xs: 12, md: 4}}>
                    <PickCard id={v.id} gameMode={v.name} description={v.description} />
                </Grid>);
            })}
        </Grid>
    );
};

export default Create;